import { render, staticRenderFns } from "./PricePanelView.vue?vue&type=template&id=6475fc19"
import script from "./PricePanelView.vue?vue&type=script&lang=js"
export * from "./PricePanelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports